import { BackHandler } from 'react-native';

export const TWCBackHandler = BackHandler;
